import React, { createContext, useContext, useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';

const OTPContext = createContext();

export const useOTP = () => useContext(OTPContext);

export const OTPProvider = ({ children }) => {
  const getInitialOTPStatus = () => {
    const token = localStorage.getItem('OTP_TOKEN');
    if (!token) {
      return { verified: false, expired: false };
    }
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decodedToken.exp > currentTime) {
        return { verified: true, expired: false };
      }
      // token exists but expired
      localStorage.removeItem('OTP_TOKEN');
      return { verified: false, expired: true };
    } catch (error) {
      // invalid token
      localStorage.removeItem('OTP_TOKEN');
      return { verified: false, expired: true };
    }
  };

  const initial = getInitialOTPStatus();
  const [isOTPVerified, setIsOTPVerified] = useState(initial.verified);
  const [tokenExpired, setTokenExpired] = useState(initial.expired);

  useEffect(() => {
    // Keep a mount-time recheck in case other tabs update localStorage just before mount
    const token = localStorage.getItem('OTP_TOKEN');
    if (!token) {
      setIsOTPVerified(false);
      setTokenExpired(false);
      return;
    }
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decodedToken.exp > currentTime) {
        setIsOTPVerified(true);
        setTokenExpired(false);
      } else {
        localStorage.removeItem('OTP_TOKEN');
        setIsOTPVerified(false);
        setTokenExpired(true);
      }
    } catch (error) {
      setIsOTPVerified(false);
      setTokenExpired(true);
    }
  }, []);

  const verifyOTP = (token) => {
    setIsOTPVerified(true);
    setTokenExpired(false);
    localStorage.setItem('OTP_TOKEN', token);
  };

  const resetOTP = () => {
    setIsOTPVerified(false);
    setTokenExpired(false);
    localStorage.removeItem('OTP_TOKEN');
  };

  return (
    <OTPContext.Provider value={{ isOTPVerified, verifyOTP, resetOTP, tokenExpired }}>
      {children}
    </OTPContext.Provider>
  );
};
